











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {RequestSsw} from '@/model/resource/RequestSsw'
import {RequestSswCollection} from '@/model/collection/RequestSswCollection'
import {ListRequestSswSchema} from '@/schema/resource/RequestSsw/ListRequestSswSchema'
import {CsvRequestSswSchema} from '@/schema/resource/RequestSsw/CsvRequestSswSchema'

@Component
export default class ListRequestSswView extends Mixins(MixinQueryRouter) {
  schema = new ListRequestSswSchema()
  collection = new RequestSswCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: RequestSsw) {
    Helper.pushByName('editRequestSsw', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new RequestSswCollection().clearFilters().addFilter(params)

    await csv.listCsvRequestSsw()
    new CsvRequestSswSchema().downloadCsv(csv.all())
  }
}
